import { authFetch } from '../utils/auth';

/**
 * Fetch analytics data from the backend
 * @param {Object} params - Query parameters
 * @param {string} params.dateRange - Date range filter (day, week, month, year, custom)
 * @param {string} params.startDate - Start date for custom range
 * @param {string} params.endDate - End date for custom range
 * @param {Array<string>} params.metricTypes - Types of metrics to fetch
 * @returns {Promise<Object>} Analytics data
 */
export const fetchAnalytics = async (params) => {
  try {
    // Build query string
    const queryParams = new URLSearchParams();
    if (params.dateRange) queryParams.append('dateRange', params.dateRange);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.metricTypes && params.metricTypes.length > 0) {
      // Backend expects comma-separated string
      queryParams.append('metricTypes', params.metricTypes.join(','));
    }

    // Make actual API call to backend
    const response = await authFetch(`/api/analytics?${queryParams.toString()}`);
    
    // Check if response is ok
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }
    
    // Parse and return JSON data
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching analytics:', error);
    throw error;
  }
};

/**
 * Export analytics data
 * @param {Object} params - Export parameters
 * @param {string} params.format - Export format (csv, json, pdf)
 * @returns {Promise<Blob>} Exported file
 */
export const exportAnalytics = async (params) => {
  try {
    // TODO: Replace with actual API call when backend is ready
    // const response = await authFetch('/api/analytics/export', {
    //   method: 'POST',
    //   body: JSON.stringify(params)
    // });
    // return response;

    throw new Error('Export functionality will be implemented when backend is ready');
  } catch (error) {
    console.error('Error exporting analytics:', error);
    throw error;
  }
};


